import { motion } from "framer-motion";

export const Tree = ({ x, y, s = 1, delay = 0 }) => (
  <g transform={`translate(${x} ${y}) scale(${s})`}>
    <ellipse cx="0" cy="4" rx="34" ry="10" fill="rgba(0,0,0,0.22)" />
    <rect x="-7" y="-40" width="14" height="44" rx="4" fill="#7a4b2a" />
    <motion.g animate={{ rotate: [-1.5, 1.5, -1.5] }} transition={{ repeat: Infinity, duration: 5, delay }} style={{ originX: "0px", originY: "-40px" }}>
      <circle cx="0" cy="-70" r="34" fill="#2f8a45" />
      <circle cx="-24" cy="-52" r="22" fill="#38a052" />
      <circle cx="24" cy="-52" r="22" fill="#38a052" />
      <circle cx="-8" cy="-84" r="16" fill="#49b863" />
      <circle cx="12" cy="-62" r="6" fill="#ff7a1a" />
      <circle cx="-16" cy="-70" r="5" fill="#ff7a1a" />
    </motion.g>
  </g>
);

export const Barn = ({ x, y }) => (
  <g transform={`translate(${x} ${y})`}>
    <ellipse cx="0" cy="6" rx="95" ry="20" fill="rgba(0,0,0,0.22)" />
    <polygon points="-80,0 0,30 0,-50 -80,-80" fill="#b5332e" />
    <polygon points="0,30 70,0 70,-80 0,-50" fill="#8f2622" />
    <polygon points="-80,-80 -40,-130 30,-100 0,-50" fill="#4a3b36" />
    <polygon points="0,-50 30,-100 70,-80" fill="#3a2e2a" />
    <polygon points="-55,-2 -25,10 -25,-40 -55,-52" fill="#f3e3c3" />
    <polygon points="-52,-4 -28,6 -28,-36 -52,-47" fill="#7a1f1b" />
    <path d="M-52 -4 L-28 -36 M-52 -47 L-28 6" stroke="#f3e3c3" strokeWidth="3" />
    <polygon points="-48,-70 -32,-64 -32,-80 -48,-86" fill="#f3e3c3" />
    <polygon points="20,4 50,-8 50,-40 20,-28" fill="#f3e3c3" opacity="0.15" />
  </g>
);

export const Pond = ({ x, y }) => (
  <g transform={`translate(${x} ${y})`}>
    <ellipse cx="0" cy="0" rx="92" ry="42" fill="#6b8f3a" />
    <ellipse cx="0" cy="-2" rx="82" ry="35" fill="#2a8fd0" />
    <ellipse cx="-10" cy="-6" rx="60" ry="22" fill="#45b0ea" />
    <motion.ellipse cx="20" cy="-4" ry="5" fill="none" stroke="#bfe9ff" strokeWidth="2"
      initial={{ rx: 10, opacity: 0.9 }} animate={{ rx: [10, 30], opacity: [0.9, 0] }} transition={{ repeat: Infinity, duration: 2.6 }} />
    <ellipse cx="-38" cy="6" rx="12" ry="5" fill="#3fae48" />
    <circle cx="-34" cy="4" r="3" fill="#ff8fc7" />
    <path d="M58 -18 l0 -26 M64 -16 l2 -22 M52 -16 l-3 -20" stroke="#3a7d2f" strokeWidth="3" strokeLinecap="round" />
    <ellipse cx="58" cy="-46" rx="3" ry="7" fill="#7a4b2a" />
  </g>
);

export const FenceLine = ({ from, to, posts = 9 }) => {
  const pts = Array.from({ length: posts }, (_, i) => [from[0] + ((to[0] - from[0]) * i) / (posts - 1), from[1] + ((to[1] - from[1]) * i) / (posts - 1)]);
  return (
    <g>
      <line x1={from[0]} y1={from[1] - 12} x2={to[0]} y2={to[1] - 12} stroke="#c58b4d" strokeWidth="5" strokeLinecap="round" />
      <line x1={from[0]} y1={from[1] - 24} x2={to[0]} y2={to[1] - 24} stroke="#d99d5c" strokeWidth="5" strokeLinecap="round" />
      {pts.map(([x, y]) => (
        <g key={`${x}-${y}`}>
          <rect x={x - 3.5} y={y - 32} width="7" height="34" rx="2" fill="#a86f38" />
          <polygon points={`${x - 3.5},${y - 32} ${x},${y - 37} ${x + 3.5},${y - 32}`} fill="#a86f38" />
        </g>
      ))}
    </g>
  );
};

export const GrassTuft = ({ x, y, delay = 0 }) => (
  <motion.g animate={{ skewX: [-6, 6, -6] }} transition={{ repeat: Infinity, duration: 3.2, delay }} style={{ originX: `${x}px`, originY: `${y}px` }}>
    <path d={`M${x} ${y} q-4 -10 -9 -14 M${x} ${y} q0 -12 1 -18 M${x} ${y} q4 -9 10 -13`} stroke="#5ccf5a" strokeWidth="2.4" fill="none" strokeLinecap="round" />
  </motion.g>
);

export const Flower = ({ x, y, c = "#ffd84d" }) => (
  <g>
    <path d={`M${x} ${y} l0 -8`} stroke="#3a9a3f" strokeWidth="1.6" />
    <circle cx={x} cy={y - 9} r="3" fill={c} />
    <circle cx={x} cy={y - 9} r="1.2" fill="#fff6d0" />
  </g>
);
